<template>
  <div class="info-flyout">
    <!-- Toggle button -->
    <div
      :class="{
        'toggle-button': true,
        'info-flyout__toggle-button': true,
        'info-flyout__toggle-button--no-bottom-margin': !isOpened,
      }"
      @click="isOpened = !isOpened"
    >
      <IconEmbedded v-if="!isOpened" class="toggle-button__caret-icon" name="caret-bottom_4" :size="14" color="rgba(17, 134, 137, 1)" />
      <IconEmbedded v-else class="toggle-button__caret-icon" name="caret-top_4" :size="14" color="rgba(17, 134, 137, 1)" />

      <div class="toggle-button__divider"></div>

      <IconEmbedded class="toggle-button__bulb-icon" name="bulb_2-5" :size="17" color="rgba(17, 134, 137, 1)" />
      <div class="toggle-button__text">How does this work?</div>
    </div>
    <!-- / Toggle button -->

    <TransitionedHeightAuto :isOpened="isOpened">
      <div class="info-flyout__content">
        <div class="info-flyout__content-left-col">
          <!--<div class="info-flyout__plain-text">
            {{
              `Rich content via the Shrpa Creator Network and Shrpa support and guarantees. Creators that visit your destination, highlight locations with your guidance, and deliver photos, videos, and Shrpa adventures.`
            }}
          </div>-->

          <ul class="info-flyout__stages-list">
            <!-- Stage snippet -->
            <li
              :class="{
                'stage-snippet': true,
                'stage-snippet--first': index === 0,
                'stage-snippet--last': index === stagesList.length - 1,
                'info-flyout__stage-snippet': true,
              }"
              v-for="(stage, index) in stagesList"
              :key="stage.title"
            >
              <div class="stage-snippet__number">
                {{ index + 1 }}
              </div>
              <div class="stage-snippet__text-container">
                <h4 class="global-h4 stage-snippet__title">
                  {{ stage.title }}
                </h4>
                <div class="stage-snippet__description">
                  {{ stage.description }}
                </div>
              </div>
            </li>
            <!-- / Stage snippet -->
          </ul>
        </div>

        <div class="info-flyout__content-right-col">
          <h3 class="global-h3" style="margin-bottom: 10px">FAQ</h3>
          <ul class="global-ul">
            <li>Does this replace my current Social Scheduler like Hootsuite? Yep, it can.</li>
            <li>Can I edit posts before it goes live? Yes, you review and approve all posts.</li>
            <li>Can I add my own content to the calendar? Yep, upload content at any time.</li>
            <li>How often do I get new posts? 2 weeks in advance we generate posts for the upcoming 2 weeks for you to review and approve. Ex. Sept 1 we create for the last 2 weeks in Sept.</li>
            <li>Can I re-generate posts? Yes, you can re-generate posts as many times as needed.</li>
          </ul>
        </div>
      </div>
    </TransitionedHeightAuto>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

// Components
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import TransitionedHeightAuto from "@components/ui/TransitionedHeightAuto.vue";

// Stages list ================================================================
const stagesList = [
  {
    title: "Review Generated Posts",
    description: "We'll create social posts from your content which you can edit, approve, or replace before they go live.",
  },
  {
    title: "Adjust your Settings and Preferences",
    description: "Adjust any interests, themes, and events you want your calendar to focus on, which we'll use when generating posts.",
  },
  {
    title: "Finalize & Schedule",
    description: "Lock in your posting schedule and we'll automatically publish to your connected social accounts.",
  },
];

// Is Opened ==================================================================
const isOpened = ref<boolean>(false);
</script>

<style scoped lang="scss">
@import "@/scss/howDoesItWorkSpoiler.scss";
</style>
